module.exports = __webpack_public_path__ + "1345c4052ee1efd70af40d82301f04ed.fbx";